import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import LoadableComponent from "../Loading/LoadableComponent";
import TextField from "@material-ui/core/TextField";
import { Identifiable } from "../../models/Identifiable";
import { GET_ALL_ZONE, GET_ZONE_BY_EXERCISE_AND_DATE } from "../../api/apiRoutes";
import getId from "../../utils/getId";
import { Zone } from "../../models/Zone";
import getObjectIds from "../../utils/getObjectIds";
import useRequest from "../../utils/hook/requestHook";
import { get } from "../../api";
import { format } from "date-fns";
import { TENIS_TYPE } from "../../components/MainPage";

interface IProps {
  zoneIds: Identifiable;
  setZoneIds: (zoneIds: Identifiable) => void;
  date?: Date;
}

const ZoneSelector: React.FC<IProps> = ({ zoneIds, setZoneIds, date }) => {
  const tenisType = sessionStorage.getItem(TENIS_TYPE);
  const [data, loading] = useRequest<Zone[]>(
    async (signal: AbortSignal) =>
      await get(
        GET_ZONE_BY_EXERCISE_AND_DATE(date ? format(date, "yyyy-MM-dd") : format(new Date(), "yyyy-MM-dd")),
        signal
      )
  );

  return (
    <LoadableComponent loading={loading}>
      <TextField
        variant="outlined"
        select
        fullWidth
        margin={"dense"}
        label={"Wybierz strefę"}
        value={getId(zoneIds)}
        onChange={(e) =>
          setZoneIds({
            objectDb: getObjectIds(e.target.value) ? Number(getObjectIds(e.target.value)?.objectDb) : 0,
            objectId: getObjectIds(e.target.value) ? Number(getObjectIds(e.target.value)?.objectId) : 0,
          } as Identifiable)
        }
      >
        <MenuItem value={"0,0"}>Wszystkie</MenuItem>
        {tenisType !== null
          ? JSON.parse(tenisType) === "hala"
            ? data
                ?.filter((item) => item.name.toLowerCase().search("hala") > -1)
                .map((item) => (
                  <MenuItem key={item.objectId} value={getId(item)}>
                    {item.name}
                  </MenuItem>
                ))
            : data
                ?.filter((item) => item.name.toLowerCase().search("hala") < 0)
                .map((item) => (
                  <MenuItem key={item.objectId} value={getId(item)}>
                    {item.name}
                  </MenuItem>
                ))
          : data?.map((item) => (
              <MenuItem key={item.objectId} value={getId(item)}>
                {item.name}
              </MenuItem>
            ))}
      </TextField>
    </LoadableComponent>
  );
};

export default ZoneSelector;
